import 'bootstrap/dist/css/bootstrap.css';
import { usePostHog } from 'posthog-js/react';
import * as React from 'react';
import { Badge, Button, Container, Navbar } from 'react-bootstrap';
import { REACT_APP_ENVIRONMENT_NAME } from '../config/global';
import { logOutUser } from '../service/brc';

const NavBar = ({ user: sessionUser }) => {
  const postHog = usePostHog();

  const logOut = async () => {
    let reqData = {
      email: sessionUser.email,
    };
    let response = {};
    response = await logOutUser(reqData);
    if (response && response.data && response.data[0]) {
      localStorage.setItem('user', JSON.stringify({}));
      postHog.reset();
      window.location.reload();
    }
  };

  React.useEffect(() => {
    if (REACT_APP_ENVIRONMENT_NAME) {
      document.title = `BLS ${REACT_APP_ENVIRONMENT_NAME}`;
    }
  }, []);

  return (
    <Navbar
      style={{ width: '100% !important', padding: '0px' }}
      collapseOnSelect
      bg="dark"
      variant="dark"
    >
      <Container style={{ width: '100%', padding: '20px', maxWidth: '100%' }}>
        <Navbar.Brand
          href="/"
          style={{
            display: 'flex',
            gap: '30px',
            alignItems: 'center',
          }}
        >
          <img style={{ height: '50px' }} src="/dtLogoWhiteText.svg" alt="" />
          <span>
            Brand Lift Study Dashboard{' '}
            <Badge bg="secondary" hidden={!REACT_APP_ENVIRONMENT_NAME}>
              {REACT_APP_ENVIRONMENT_NAME}
            </Badge>
          </span>
        </Navbar.Brand>
        <Navbar className="justify-content-end">
          {sessionUser && sessionUser.email && (
            <Navbar.Text className="me-2">Signed in as: {sessionUser.email}</Navbar.Text>
          )}
          {sessionUser && sessionUser.email && (
            <Button variant="secondary" onClick={() => logOut()}>
              Logout
            </Button>
          )}
        </Navbar>
      </Container>
    </Navbar>
  );
};

export default NavBar;
